// extracted by mini-css-extract-plugin
export var expandable__content = "fp-_H";
export var expandable__icon = "fp--H";
export var expandable__labels = "fp-0H";
export var expandable__title = "fp-TH";
export var grid = "fp-UH";
export var gridWithRowGap = "fp-VH";
export var maxWidthContainer = "fp-ZH";
export var mt0 = "fp-MH";
export var mt1 = "fp-NH";
export var mt2 = "fp-OH";
export var mt3 = "fp-PH";
export var mt4 = "fp-QH";
export var mt5 = "fp-RH";
export var mt6 = "fp-SH";
export var removeVisuallyHidden = "fp-XH";
export var visuallyHidden = "fp-WH";
export var widgetBase = "fp-YH";